/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useMemo, useState } from "react";

import classnames from "classnames";
import { Card, Col, Container, Nav, NavItem, NavLink, Row } from "reactstrap";

// RangeSlider
import "nouislider/distribute/nouislider.css";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import {
  deleteDraftProductApi,
  getDraftProducts as onGetProducts,
} from "../../../live-slices/products/thunk";

import deletIcon from "../../../assets/images/deleteIcon.svg";
import editIcon from "../../../assets/images/editIcon.svg";
import dummyImage from "../../../assets/images/auth-bg.png";
import buypassLogo from "../../../assets/images/favicon.png";

import ViewIcon from "../../../assets/images/viewicon.svg";
//Import data
// import { productsData } from "../../../common/data";

//Import actions

//redux
import PaginatedTable from "Components/Common/PaginatedTable";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { createSelector } from "reselect";
import { getAuthMe, updateProductToggle } from "slices/thunks";
import { Constant } from "utils/enums";
import { postRefreshAuth } from "helpers/backend_helper";

const productStatuses = [
  { label: "All", value: "all", countKey: "allCount", count: 0 },
  { label: "Active", value: "active", countKey: "activeCount", count: 0 },
  { label: "Pending", value: "pending", countKey: "pendingCount", count: 0 },
  {
    label: "In Active",
    value: "inactive",
    countKey: "inActiveCount",
    count: 0,
  },
];

const EcommerceDraftProducts = (props: any) => {
  document.title = "Products | BuyPass";
  const dispatch: any = useDispatch();
  const selecteCountData = createSelector(
    (state: any) => state.Product,
    (Ecommerce) => Ecommerce?.counts
  );
  const selectecomproductData = createSelector(
    (state: any) => state.Product,
    (products) => products?.products
  );

  const products = useSelector(selectecomproductData);
  const counts = useSelector(selecteCountData);
  const [tabs, setTabs] = useState<any[]>(productStatuses);
  const [activeTab, setActiveTab] = useState<any>(productStatuses[0].value);
  const [productList, setProductList] = useState<any>([]);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [dele, setDele] = useState(0);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const navigate = useNavigate();

  const onClickDelete = (product: any) => {
    setSelectedProductId(product._id);
    setDeleteModal(true); // Open the modal
  };

  const handleDeleteConfirm = async () => {
    if (selectedProductId) {
      const productIndex = products.findIndex(
        (product: { _id: string }) => product._id === selectedProductId
      );
      await dispatch(
        deleteDraftProductApi({ id: selectedProductId, navigate })
      );
      if (productIndex !== -1) {
        const updatedProducts = [...products];
        updatedProducts.splice(productIndex, 1);
        setProductList(updatedProducts);
        window.location.reload();
      }

      setDeleteModal(false);
      setSelectedProductId(null);
    }
  };

  // useEffect(() => {
  //   let pageTabs = [...tabs];
  //   for (let tab of pageTabs) {
  //     tab.count = counts[tab.countKey] ?? 0;
  //   }
  //   setTabs(pageTabs);
  // }, [counts])

  const toggleTab = (tab: any) => {
    if (activeTab !== tab.value) {
      setActiveTab(tab.value);
    }
  };

  const fetchAuthData = async () => {
    dispatch(getAuthMe());
  };

  useEffect(() => {
    try {
      let refreshToken = localStorage.getItem(Constant.refresh_token);

      if (refreshToken) {
        postRefreshAuth()
          .then((res: any) => {
            if (res && res.access_token) {
              localStorage.setItem(
                Constant.access_token,
                JSON.stringify(res.access_token)
              );
              localStorage.setItem(
                Constant.refresh_token,
                JSON.stringify(res.refresh_token)
              );
            } else {
              handleTokenExpiration();
            }
          })
          .catch((e) => {
            console.log(e);
            handleTokenExpiration();
          });
      } else {
        handleTokenExpiration();
      }
    } catch (e) {
      console.log(e);
    }

    fetchAuthData();
  }, [dispatch]);

  const handleTokenExpiration = () => {
    localStorage.removeItem(Constant.access_token);
    localStorage.removeItem(Constant.refresh_token);
    // toast.error("Token Expired");
    window.location.reload();
  };

  const onFetchData = async (params: any) => {
    const res = await dispatch(
      onGetProducts({
        page: params.pageIndex,
        count: params.pageSize,
        status: activeTab,
        keyword: params.searchQuery,
      })
    );
    return res.payload;
  };

  const Toggle = (cell: any) => {
    const [isChecked, setIsChecked] = useState(cell.getValue());
    const toggleChange = () => {
      const newToggleState = !isChecked;
      setIsChecked(newToggleState);
      const productId = cell.row.original._id;
      dispatch(
        updateProductToggle({ productId, isAvailability: newToggleState })
      );
    };

    return (
      <React.Fragment>
        <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            checked={isChecked}
            data-testing-Id="activeToggle_manageProducts"
            onChange={toggleChange}
          />
        </div>
      </React.Fragment>
    );
  };

  const displayDelete = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element") as HTMLElement;
    setDele(ele.length);
    if (ele.length === 0) {
      del.style.display = "none";
    } else {
      del.style.display = "block";
    }
  };

  const columns = useMemo(
    () => [
      // {
      //   header: "#",
      //   accessorKey: "productId",
      //   enableColumnFilter: false,
      //   enableSorting: false,
      //   cell: (cell: any) => {
      //     return <input type="checkbox" data-testing-Id={"checkBox_manageProducts" + cell.row.index} className="productCheckBox form-check-input" value={cell.getValue()} onClick={() => displayDelete()} />;
      //   },
      // },
      {
        header: "Product Info",
        accessorKey: "nameEn",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0 me-3">
                {/* <Link to={`/product/${cell.row.original._id}`} state={{ product_id: cell.row.original._id }} className="text-primary d-inline-block" data-testing-Id={"ProductDetail_manageProducts" + cell.row.index} > */}
                <div
                  className="avatar-sm bg-light rounded-4 d-flex justify-content-center align-items-center"
                  style={{ width: "80px", height: "80px" }}
                >
                  <img
                    src={
                      cell.row.original.productImages?.length > 0
                        ? cell.row.original.productImages[0].url
                        : buypassLogo
                    }
                    alt=""
                    className="img-fluid d-block rounded-4 "
                    style={{ width: "75px", height: "75px" }}
                  />
                </div>
                {/* </Link> */}
              </div>
              <div className="flex-grow-1">
                {/* <Link to={`/product/${cell.row.original._id}`} state={{ product_id: cell.row.original._id }} className="text-primary d-inline-block" data-testing-Id={"ProductDetail_manageProducts" + cell.row.index} > */}

                <h5 className="fs-14 mb-1">{cell.getValue()}</h5>
                <p className="text-muted mb-0">
                  Description :{" "}
                  <span className="fw-medium">
                    {cell.row.original.description.mainDescription
                      ? cell.row.original.description.mainDescription
                      : "-"}
                  </span>
                </p>
                {/* </Link> */}
              </div>
            </div>
          </>
        ),
      },
      {
        header: "Date",
        accessorKey: "createdOn",
        enableColumnFilter: false,
        cell: ({ getValue }) => {
          const timestamp = getValue(); // Get the numeric value
          const date = new Date(timestamp); // Convert it to a Date object
          return date.toLocaleDateString(); // Format it to a readable date string
        },
      },
      {
        header: "Action",
        cell: (cellProps: any) => {
          return (
            <>
              <ul className="list-inline hstack gap-2 mb-0">
                {/* <li className="list-inline-item">
                <Link
                  to={`/product/${cellProps.row.original._id}`}
                  state={{ product_id: cellProps.row.original._id }}
                  target="_blank"
                  className="text-primary d-inline-block"
                >
                  <img src={ViewIcon} alt="" style={{ width: "20px", height: "20px" }} data-testing-Id={"eyeIcon_manageProducts" + cellProps.row.index} />
                </Link>
              </li> */}
                <li className="list-inline-item">
                  <Link
                    to={`/draft/edit/${cellProps.row.original._id}`}
                    state={{ product_id: cellProps.row.original._id }}
                    className="text-primary d-inline-block"
                  >
                    {/* <i className="ri-pencil-fill text-secondary fs-16" data-testing-Id={"editIcon_manageProducts" + cellProps.row.index}></i> */}
                    <img
                      src={editIcon}
                      alt=""
                      style={{ width: "20px", height: "20px" }}
                      data-testing-Id={
                        "editIcon_DraftProducts" + cellProps.row.index
                      }
                    />
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-danger d-inline-block remove-item-btn"
                    onClick={() => {
                      const productData = cellProps.row.original;
                      onClickDelete(productData);
                    }}
                  >
                    <img
                      src={deletIcon}
                      alt=""
                      style={{ width: "20px", height: "20px" }}
                      data-testing-id={
                        "deleteIcon_DraftProducts" + cellProps.row.index
                      }
                    />
                  </Link>
                </li>
              </ul>
            </>
          );
        },
      },
    ],
    []
  );

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} limit={1} />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={() => handleDeleteConfirm()}
        onCloseClick={() => {
          setDeleteModal(false);
          setSelectedProductId(null);
        }}
      />
      <Container fluid>
        <BreadCrumb
          title="Draft Products"
          pageTitle="Products"
          pageTitleRoute="/draft-products"
        />
        <Row>
          <Col xl={12} lg={12}>
            <div>
              <Card>
                <div className="card-header border-0">
                  <Row className=" align-items-center">
                    <div className="col-auto">
                      <div id="selection-element">
                        <div className="my-n1 d-flex align-items-center text-muted">
                          Select{" "}
                          <div
                            id="select-content"
                            className="text-body fw-semibold px-1"
                          >
                            {dele}
                          </div>{" "}
                          Result{" "}
                          <button
                            type="button"
                            className="btn btn-link link-danger p-0 ms-3"
                            onClick={() => setDeleteModal(true)}
                            data-testing-Id="removebutton_manageProducts"
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    </div>
                  </Row>
                </div>
                <div className="card-body pt-0">
                  <PaginatedTable
                    key={activeTab}
                    columns={columns}
                    divClass="table-responsive mb-1"
                    tableClass="mb-0 align-middle table-borderless"
                    theadClass="table-light text-muted"
                    fetchData={(params) => onFetchData(params)}
                  ></PaginatedTable>
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default EcommerceDraftProducts;
